/**
 * Baris kuota sebuah paket, dalam urutan yang sama di mana pun ditampilkan —
 * tabel harga orisini.com dan kartu paket di halaman Billing.
 *
 * Diturunkan dari angka paketnya sendiri (`limits` + `extraLimits`), bukan dari
 * teks `features_json`, supaya tiap jenis kuota selalu jadi barisnya sendiri
 * dan angka yang tampil tidak bisa berbeda dari angka yang ditegakkan.
 */

export interface PlanLimits {
  limits: { maxAccounts: number; maxPostsPerMonth: number; maxDevices: number }
  extraLimits?: Record<string, number>
}

export interface QuotaRow {
  key: string
  label: string
  value: string
}

const angka = (n: number) => n.toLocaleString('en-US')

export function planQuotaRows(plan: PlanLimits): QuotaRow[] {
  const extra = plan.extraLimits ?? {}
  return [
    { key: 'posts', label: 'Posts per month', value: angka(plan.limits.maxPostsPerMonth) },
    { key: 'accounts', label: 'Connected accounts', value: angka(plan.limits.maxAccounts) },
    { key: 'posters', label: 'Posters per month', value: angka(extra.postersPerMonth ?? 0) },
    { key: 'carousels', label: 'Carousels per month', value: angka(extra.carouselsPerMonth ?? 0) },
    { key: 'videos', label: 'Videos per month', value: angka(extra.videosPerMonth ?? 0) },
    { key: 'devices', label: 'Devices', value: angka(plan.limits.maxDevices) },
  ]
}
